import Vue from 'vue'
import Router from 'vue-router'
import routerMap from './module/index.map'
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: routerMap
})

export default router
